import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Datetime from "react-datetime";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class TopUpPayoutWalletComponent extends Component {
  state = {
    topUpPayoutWalletForm: new Form(
      {
        midCurrency: "",
        availableBalance: "",
        payoutFee: "",
        topUpAmount: "",
        topUpFee: ""
      },
      [
        {
          name: "midCurrency",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "topUpAmount",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    ),
  };

  getTopUpPayoutWalletFields = (payoutFee) => [
    [
      {
        name: "midCurrency",
        label: "MID Currency",
        disabled: true,
        fieldType: "input",
        flexGrow: 4,
      },
      {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        flexGrow: 10,
      },
      {
        name: "topUpAmount",
        label: "Top Up Amount",
        fieldType: "input",
        flexGrow: 10,
        placeholder: `Payout fee: ${payoutFee || 0}%`,
      },
      {
        name: "topUpFee",
        label: "Fee",
        fieldType: "input",
        disabled: true,
        flexGrow: 5,
      },
      { fieldType: "empty" },
    ],
    [
      { fieldType: "empty" },
      { fieldType: "empty" },
      { fieldType: "empty" },
      { fieldType: "empty" },
      { fieldType: "button" },
    ],
  ];

  onSaveDataEntries = () => {
    const { savedData, form } = this.props;

    const isFormValid = form.isFormValid();
    this.saveValidationUpdate(form, isFormValid, isFormValid);

    if (isFormValid) {
      const data = {
        merchantId: parseInt(savedData.merchant),
        midId: savedData.midIds,
        date: savedData.date.format("DD.MM.yyyy HH:mm:ss"),
        topUpAmount: parseFloat(form.topUpAmount, 2),
        payoutFee: form.payoutFee,
        availableBalanceAmount: form.availableBalance,
        currency: form.midCurrency,
      };

      crudActions.post(`v1/data/input/payout/top-up`, data)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });
    }
  };
  
  onChangeFilter = () => {
    const { controls, date } = this.props;
    const { topUpPayoutWalletForm } = this.state;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);
    
    const formattedDate = Datetime.moment(date).format("DD.MM.YYYY");

    if (isFormValid) {
      const { merchant, dataType, midIds } = controls;

      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }&midIds=${ midIds }&date=${ formattedDate }`;
      
      crudActions.get(url)
        .then((response) => {
          Object.assign(topUpPayoutWalletForm, {
            midCurrency: response.currency || "",
            availableBalance: parseFloat(response.availableBalanceAmount) || 0,
            payoutFee: response?.payoutFee || 0,
            topUpAmount: "",
            topUpFee: 0
          });
          Object.assign(controls, {
            topUpDate: response.date || "",
          });
          const newState = {
            topUpPayoutWalletForm: topUpPayoutWalletForm,
            controls
          };
          Object.assign(newState, {
            showSecondPanel: true,
            loadingDataInput: false,
            lockButton: false,
          });
          this.updateField(DATA_TYPES.TOP_UP_PAYOUT_WALLET, this.getTopUpPayoutWalletFields(topUpPayoutWalletForm.payoutFee));
          this.updateState(newState);
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };
  
  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };

  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default TopUpPayoutWalletComponent;